import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { SubstructureMaterial } from "../../../../http/deckDesigner/types/substructureMaterials";
import useDeckSubstructureMaterialsApi from "../../../../http/deckDesigner/useSubstructureMaterials";
import SubstructureMaterialForm from "./SubstructureMaterialForm";

const AdminSubstructureMaterials: FC = () => {
  const i18n = useI18n();
  const substructureMaterialsApi = useDeckSubstructureMaterialsApi();

  return (
    <AdminCrudTable<SubstructureMaterial>
      filterPrefix="substructure_materials"
      useList={substructureMaterialsApi.useDeckSubstructureMaterials}
      head={<TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>}
      renderRow={(item) => <TableCell>{item.name}</TableCell>}
      renderForm={(item, onClose) => <SubstructureMaterialForm substructureMaterial={item} onClose={onClose} />}
    />
  );
};

export default AdminSubstructureMaterials;
